import { FileInput } from '@mitchell/react.component.ux';
import { connect } from 'react-redux';
import { getOnFilesSelected } from './fileInputContainerHelper';
const mapDispatchToProps = (dispatch, ownProps) => {
    const onSelected = getOnFilesSelected(dispatch, ownProps);
    return { onSelected };
};
export const ConnectedFileInput = connect(null, mapDispatchToProps)(FileInput);
//# sourceMappingURL=ConnectedFileInput.js.map